// extracted by mini-css-extract-plugin
export default {"badge":"badge__CQqROOB1h0hd"};